/* @ngInject */

export default ($parse) => {
  return {
    require: 'ngModel',
    restrict: 'A',
    scope: {
      length: '@',
      lower: '@',
      upper: '@',
      digit: '@',
      symbol: '@'
    },
    link: function (scope, elem, attrs, ctrl) {
      // scope.$watch(function () {
      //     return (ctrl.$pristine && angular.isUndefined(ctrl.$modelValue)) || $parse(attrs.match)(scope) === ctrl.$modelValue;
      // }, function (currentValue) {
      //     ctrl.$setValidity('match', currentValue);
      // });
      ctrl.$setValidity('policyLength', true);
      ctrl.$setValidity('policyLowercase', true);
      ctrl.$setValidity('policyUppercase', true);
      ctrl.$setValidity('policyDigits', true);
      ctrl.$setValidity('policySymbols', true);
      ctrl.$setValidity('policy', true);
      ctrl.$parsers.unshift(function (viewValue) {
        var hasLength = viewValue && viewValue.length >= attrs.length;
        var hasLowercase =
          attrs.lower !== 'false' ? viewValue && /[a-z]/.test(viewValue) : true;
        var hasUppercase =
          attrs.upper !== 'false' ? viewValue && /[A-Z]/.test(viewValue) : true;
        var hasDigits = attrs.digit !== 'false' ? viewValue && /\d/.test(viewValue) : true;
        var hasSymbols =
          attrs.symbol !== 'false'
            ? viewValue &&
              (/[!@£#\$%\^&\*\(\)\-_=\+]/.test(viewValue) ||
                /[\?\/\.>\,<`~\\|"';:\]\}\[\{\s]/.test(viewValue))
            : true;
        ctrl.$setValidity('policyLength', hasLength);
        ctrl.$setValidity('policyLowercase', hasLowercase);
        ctrl.$setValidity('policyUppercase', hasUppercase);
        ctrl.$setValidity('policyDigits', hasDigits);
        ctrl.$setValidity('policySymbols', hasSymbols);
        ctrl.$setValidity(
          'policy',
          hasLength && hasLowercase && hasUppercase && hasDigits && hasSymbols
        );
        ctrl.$setTouched();
        ctrl.$setDirty();
        return viewValue;
      });
    }
  };
};
